import React, { useEffect, useMemo, useState } from 'react';
import { logoutListeners, wsLink } from '../ApolloInjector';
import { gql, useLazyQuery } from '@apollo/client';
import UserContext from '../../context/UserContext';
import AuthRefresh from '../../context/AuthRefresh';
import { PrivilegesContext } from '../../context/PrivilegesContext';

export default function AuthManager({ children }) {
	const [ user, setUser ] = useState(null);

	const [ refreshUser, userQuery ] = useLazyQuery(gql`{
        whoami {
            id,
            firstName,
            fullName,
            email,
	        dockWorkerRole {
	        	id,
	        	workbookNr
            },
	        authRoles {
				id,
	            name,
	            privileges	        
	        }
        }
    }`, {
		onCompleted: (data) => {
			console.log('Received whoami data', data?.whoami);
		},
	});

	useEffect(() => {
		refreshUser();

		function setUserNull() {
			setUser(null);
		}

		logoutListeners.push(setUserNull);

		return () => {
			logoutListeners.splice(logoutListeners.indexOf(setUserNull), 1);
		};
	}, []);

	useEffect(() => {
		if (userQuery.data != null) {
			console.log('Updating user state', userQuery.data.whoami);
			setUser({ ...userQuery.data.whoami });

			// Reconnect websocket if auth has changed (it'll automatically reconnect)
			wsLink.subscriptionClient.close(false);
		}
	}, [ userQuery.data ]);

	const privileges = useMemo(() => {
		return new Set(user?.authRoles?.flatMap(role => role.privileges) ?? []);
	}, [ user ]);

	return <UserContext.Provider value={user}>
		<AuthRefresh.Provider value={refreshUser}>
			<PrivilegesContext.Provider value={privileges}>
				{children}
			</PrivilegesContext.Provider>
		</AuthRefresh.Provider>
	</UserContext.Provider>;
}